export class HubFeed {
  public id: string;
  public name: string;
  public title: string;
  public cityTitle: string;
  public cityImage: string;
  public socialName: string;
  public radius: number;
  public hubName: string;
  public categories: string;
  public lat: number;
  public lng: number;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/models/hub/hub.feed.ts